import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../public/services';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss'],
})
export class UserAccountComponent implements OnInit {
  formSubmitAttempt: boolean;
  relaxed: boolean;

  loading: boolean;
  success: boolean;
  error: any;

  returnUrl: string;
  theDestParamterIsentYou: string;
  image;
  userImg;
  name: string;
  baseUrl: any = environment.API_SERVER;
  otp: boolean = false;
  firstName;
  lastName;
  private unsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    private userSvc: UserService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.theDestParamterIsentYou = params['dest'];
      this.lg();
    });

    this.image = window.localStorage.getItem('user');
    let firstName = this.image != null ? JSON.parse(this.image)['firstName'] : '';
    let lastName = this.image != null ? JSON.parse(this.image)['lastName'] : '';
    this.name = `${firstName} ${lastName}`;
    this.userImg = this.image != null ? JSON.parse(this.image)['image'] : '';
    this.image =
      this.userImg !== 'null' &&
      this.userImg !== undefined &&
      this.userImg !== null
        ? `${this.baseUrl}/public/image/?media=${this.userImg}`
        : `/assets/avatar/1.jpg`;
  }

  ngOnInit(): void {
    if(this.image == null) {
      this.router.navigate(['home-page/login']);
    }
  }

  lg() {
    function getParameterByName(name) {
      const url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&]*)|&|$)'),
        results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    this.returnUrl = getParameterByName('return_url');
    // console.log(this.returnUrl);
  }

  logout() {
    this.userSvc.identityLogout('').subscribe((res) => {
      window.location.replace(
        `${this.baseUrl}/identity/continue/?return_url=${encodeURIComponent(
          this.returnUrl
        )}&dest=${encodeURIComponent(this.theDestParamterIsentYou)}`
      );
    });
  }
  continue() {
    window.location.replace(
      `${this.baseUrl}/identity/continue/?return_url=${encodeURIComponent(
        this.returnUrl
      )}`
    );
  }
}
